import { z } from "zod";
import {
  DomainModelMetaExtendedSchema,
  DomainModelMetaSchema,
} from "../util/index.ts";
import { NodeAPIFilterSchema } from "./FilterSchemas.ts";

export const PermissionGrant = {
  READ: "read",
  READ_ALL: "read_all",
  WRITE: "write",
  WRITE_ACTIONS: "write_actions",
  EDIT: "edit",
  DELETE: "delete",
  DELETE_ADMIN: "delete_admin",
  LOCK: "lock",
  ASSIGN: "assign",
  ACCESS: "access",
  APPROVE: "approve",
  CALC: "calc",
} as const;

const PERMISSION_NAME_REGEX = new RegExp(
  `^[a-z]+[a-z_]+:(${Object.values(PermissionGrant).join("|")})$`
);

export const checkIsPermissionGrantType = (
  grant: string
): grant is PermissionGrantType =>
  Object.values(PermissionGrant).some((g) => g === grant);

export const checkIsPermissionNameType = (
  permissionName: string
): permissionName is PermissionNameType =>
  PERMISSION_NAME_REGEX.test(permissionName);

export const PermissionSchema = z.object({
  name: z.string().regex(PERMISSION_NAME_REGEX),
});

export const UserPermissionSchema = z.object({
  name: z.string().regex(PERMISSION_NAME_REGEX),
  active: z.boolean(),
  filter: NodeAPIFilterSchema,
});

export const RolePermissionSchema = UserPermissionSchema.merge(
  z.object({
    group_id: z.string().uuid(),
  })
)
  .merge(DomainModelMetaSchema)
  .merge(DomainModelMetaExtendedSchema);

export type PermissionType = z.infer<typeof PermissionSchema>;
export type PermissionGrantType =
  (typeof PermissionGrant)[keyof typeof PermissionGrant];
export type PermissionNameType = `${string}:${PermissionGrantType}`;
export type UserPermissionType = z.infer<typeof UserPermissionSchema>;
export type RolePermissionType = z.infer<typeof RolePermissionSchema>;
